import { api } from './client';
import type { InstallerTask, Collector, PhotoItem } from '@/types/odoo';

export async function fetchInstallerTasks(): Promise<InstallerTask[]> {
  const res = await api<{ tasks: InstallerTask[] }>('/api/installer/tasks');
  return res.tasks;
}

export async function fetchInstallerCollectoren(projectId: number): Promise<{ collectors: Collector[]; installerNames: Record<string, string> }> {
  return api<{ collectors: Collector[]; installerNames: Record<string, string> }>(`/api/installer/projects/${projectId}/collectoren`);
}

export async function patchCollectorOpDruk(
  projectId: number, taskId: number, value = true, installerId?: number, datum?: string
): Promise<void> {
  const body: Record<string, unknown> = { field: 'x_studio_collector_op_druk', value };
  if (installerId !== undefined) body.installerId = installerId;
  if (datum) body.datum = datum;
  await api(`/api/projects/${projectId}/collectoren/${taskId}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export async function patchCollectorInstallateur(
  projectId: number, taskId: number, installerId?: number
): Promise<void> {
  await api(`/api/projects/${projectId}/collectoren/${taskId}`, {
    method: 'PATCH',
    body: JSON.stringify({
      field: 'x_studio_collector_installateur',
      value: true,
      installerId: installerId ?? 0,
    }),
  });
}

// Drukattest photos — blok level
export async function uploadDrukattestPhoto(
  projectId: number, file: File, projectName: string, blokName: string
): Promise<{ key: string }> {
  const formData = new FormData();
  formData.append('projectName', projectName);
  formData.append('blokName', blokName);
  formData.append('file', file);
  return api<{ key: string }>(`/api/photos/drukattest/${projectId}`, {
    method: 'POST',
    body: formData,
  });
}

export async function listDrukattestPhotos(
  projectId: number, projectName: string, blokName: string
): Promise<PhotoItem[]> {
  const params = new URLSearchParams({ projectName, blokName });
  const res = await api<{ photos: PhotoItem[] }>(`/api/photos/drukattest/${projectId}?${params}`);
  return res.photos;
}

export async function deleteDrukattestPhoto(projectId: number, key: string): Promise<void> {
  await api(`/api/photos/drukattest/${projectId}`, {
    method: 'DELETE',
    body: JSON.stringify({ key }),
  });
}
